/**
 * outages.js
 */
const $ = window.jQuery;

import Attribution from "ol/control/Attribution.js";
import Circle from "ol/geom/Circle.js";
import Collection from "ol/Collection.js";
import Feature from "ol/Feature.js";
import Fill from "ol/style/Fill.js";
import Icon from "ol/style/Icon.js";
import LayerGroup from "ol/layer/Group.js";
import Map from "ol/Map.js";
import Overlay from "ol/Overlay.js";
import Point from "ol/geom/Point.js";
import Rotate from "ol/control/Rotate.js";
import Style from "ol/style/Style.js";
import Text from "ol/style/Text.js";
import VectorLayer from "ol/layer/Vector.js";
import VectorSource from "ol/source/Vector.js";
import View from "ol/View.js";
import Zoom from "ol/control/Zoom.js";
import { fromLonLat } from "ol/proj.js";
import { transform } from "ol/proj.js";

// vector maps
import { apply } from "ol-mapbox-style";

import flatpickr from "flatpickr";
import fpLightCss from "flatpickr/dist/flatpickr.min.css?raw";
import fpDarkCss from "flatpickr/dist/themes/dark.css?raw";

import ClipboardJS from "clipboard";

import { DrillDown } from "./ddown.js";
import { Sidepanel } from "./sidepanel.js";
import { heatmap } from "./hm.js";

const { outageState, OUTAGE_CONFIG, debug } = window.appConfig;

const fpLightStyle = document.createElement("style");
fpLightStyle.textContent = fpLightCss;
fpLightStyle.disabled = true;

const fpDarkStyle = document.createElement("style");
fpDarkStyle.textContent = fpDarkCss;
fpDarkStyle.disabled = false; // dark initially

document.head.append(fpLightStyle, fpDarkStyle);

$(document).ready(function () {
  // Initialize map settings
  const playbackIvalMs = 1000;
  const clearStyle = new Style({});
  const hIcon = new Icon({
    anchor: [0.5, 0.5],
    anchorXUnits: "fraction",
    anchorYUnits: "fraction",
    opacity: 0.8,
    scale: 43 / 512,
    src: "assets/img/hg.png",
  });
  const poiSource = new VectorSource();
  const poiLayer = new VectorLayer({
    source: poiSource,
  });
  const hurricaneSource = new VectorSource();
  const hurricaneLayer = new VectorLayer({
    source: hurricaneSource,
  });
  let playbackIsActive = false,
    playbackSpeed = 1;
  let curTS = "";
  let fpInstance = null;

  // Updates the control interface
  function refreshTimeControls() {
    // Previous button
    const prevTS = outageState.timestamp_prev;
    if (prevTS === 0 && !$("#ts-prev").hasClass("off")) {
      $("#ts-prev").addClass("off");
    } else if (prevTS > 0 && $("#ts-prev").hasClass("off")) {
      $("#ts-prev").removeClass("off");
    }
    // Next button
    const nextTS = outageState.timestamp_next;
    if (nextTS === 0 && !$("#ts-next").hasClass("off")) {
      $("#ts-next").addClass("off");
    } else if (nextTS > 0 && $("#ts-next").hasClass("off")) {
      $("#ts-next").removeClass("off");
    }
    // Timeslider animation should be turned off if we are at the end of data
    if ($("#ts-play").hasClass("on") && outageState.timestamp_next === 0) {
      timeControlsStatus("off");
    }
    // Highlight the datepicker briefly
    //$('#datetimepicker-clone').addClass('highlight');
    //setTimeout(function() {
    //    $('#datetimepicker-clone').removeClass('highlight');
    //}, 500);
  }

  // Triggered by control-buttons player controls
  $("#control-buttons button").on("click", function () {
    const field = $(this).attr("id");
    switch (field) {
      case "ts-play":
        if (!playbackIsActive) {
          //start animation
          skipToTime(nextTimestamp(curTS, 1), "true");
          //change state AFTER the call so we don't exit xxx
          playbackIsActive = true;
        } else {
          playbackIsActive = false;
        }
        break;
      case "ts-forward":
        updatePlaybackSpeed();
        break;
      case "ts-next":
        playbackIsActive = false;
        if (outageState.timestamp_next === 0) {
          //fetch same ts?
        } else {
          skipToTime(nextTimestamp(curTS, 1), "true");
        }
        break;
      case "ts-prev":
        playbackIsActive = false;
        skipToTime(nextTimestamp(curTS, -1), "false");
        break;

      case "light-dark":
        break;

      default:
        console.log("unknown control-buttons click field: ", field);
    }
    timeControlsStatus(playbackIsActive);
  });

  // Animation speed control
  function updatePlaybackSpeed() {
    if (playbackSpeed < 8) {
      playbackSpeed *= 2;
    } else {
      playbackSpeed = 1;
    }
    outageState.speed = playbackSpeed;
    $("#play-speed").html(playbackSpeed + "x");
  }

  // Calculates elapsed time between animation frame calls
  function nextTimestamp(curTS, direction) {
    return curTS + direction * OUTAGE_CONFIG["tsInterval"] * playbackSpeed;
  }

  // Outage animation
  function timeControlsStatus(toggle) {
    const playBtn = $("#ts-play"),
      playBtnIcon = $("#ts-play i");
    if (toggle) {
      $(playBtn).addClass("on");
      $(playBtnIcon).removeClass("fa-play");
      $(playBtnIcon).addClass("fa-pause");
    } else {
      $(playBtn).removeClass("on");
      $(playBtnIcon).removeClass("fa-pause");
      $(playBtnIcon).addClass("fa-play");
    }
  }

  const setLightTheme = (isLight) => {
    document.documentElement.setAttribute(
      "data-theme",
      isLight ? "light" : "dark",
    );
    fpLightStyle.disabled = !isLight;
    fpDarkStyle.disabled = isLight;
  };

  // Create an overlay to anchor the popup to the map.
  const popupOverlay = new Overlay({
    //element: document.getElementById("popup"),
    autoPan: {
      animation: {
        duration: 250,
      },
    },
  });

  function getBasemapStyleUrl(theme) {
    const apiKey = "cb1_29el_1_327578c97869141237d32f0b";
    const url =
      theme === "dark"
        ? "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json"
        : "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json";
    return url + "?key=" + apiKey;
  }

  popupOverlay.setElement(document.getElementById("popup"));

  const basemapGroup = new LayerGroup();
  const featuresGroup = new LayerGroup({
    layers: [poiLayer, hurricaneLayer],
  });

  // Create the map
  const map = new Map({
    target: "map",
    layers: [basemapGroup, featuresGroup],
    overlays: [popupOverlay],
    view: new View({
      zoom: outageState.zoom,
      minZoom: 2,
      maxZoom: 8,
    }),
    controls: new Collection([new Zoom(), new Rotate(), new Attribution()]),
  });

  const updateMap = () => {
    const url = getBasemapStyleUrl(outageState.canvas);
    basemapGroup.getLayers().clear();

    fetch(url)
      .then((response) => response.json())
      .then((styleJson) => {
        styleJson.id = url;
        apply(basemapGroup, styleJson, {
          webfonts: "",
          getFonts: () => ["Helvetica Neue", "Arial", "sans-serif"],
        });
      });
  };

  updateMap();

  //drilldown:
  let drillDown = null;
  const ddTypes = OUTAGE_CONFIG["useDrilldowns"];
  let ddDefault = OUTAGE_CONFIG["defaultDrilldown"];
  if (ddTypes !== undefined && ddTypes !== null && ddTypes.length > 0) {
    if (ddDefault === undefined) {
      ddDefault = ddTypes[0];
    }
    drillDown = new DrillDown(
      map,
      poiLayer,
      $("#popup"),
      popupOverlay,
      outageState,
      ddTypes,
      ddDefault,
    );
  }

  //sidepanel:
  let sp = null;
  if (OUTAGE_CONFIG["useSidepanel"]) {
    sp = new Sidepanel("sidepanel", "sidepanel-button");
    const ts = sp.RoundToDay(outageState.timestamp);
    sp.SetUrl(
      "/report/?stime=" +
        ts +
        "&duration=day&rtype=interest-1-lag&grid=0.5&limit=10&template=sp_embed.html.j2",
    );
  }

  init();

  //resize text input
  /*
  const sizeSpan = document.getElementById("flatpickr-input-sizing");
  document.getElementById("flatpickr-input").style.width =
    sizeSpan.offsetWidth + "px";
  */

  const marker = new Overlay({
    positioning: "center-right",
    element: document.getElementById("hmarker"),
    stopEvent: false,
  });
  map.on("pointermove", function (evt) {
    const hitTolerance = 30;
    const f = map.forEachFeatureAtPixel(evt.pixel, (feature) => feature, {
      hitTolerance,
    });

    if (f && f.ANTlabel) {
      const e = marker.getElement();
      e.innerHTML = f.ANTlabel;
      marker.setPosition(f.ANTcoord);
      map.addOverlay(marker);
    } else {
      map.removeOverlay(marker);
    }
  });

  if (drillDown !== null) {
    // Display a drill-down popup when user clicks on circle
    map.on("click", drillDown.getOnClick(map));
  }

  let curZoom = map.getView().getZoom();
  map.on("moveend", function () {
    const view = map.getView();
    const newZoom = Math.floor(view.getZoom());
    // Zoom level changed
    if (curZoom !== newZoom) {
      outageState.zoom = newZoom;
      // Load new data on resolution zoom triggers
      // check if the zoom "band" has changed
      if (
        (curZoom <= 4 && newZoom <= 4) ||
        (curZoom >= 5 && curZoom <= 6 && newZoom >= 5 && newZoom <= 6) ||
        (curZoom >= 7 && newZoom >= 7)
      ) {
        //both old and new fall into the same band, all good
        curZoom = newZoom;
      } else {
        //need to load new data
        if (drillDown !== null) {
          drillDown.closePopup();
        }
        curZoom = newZoom;
        skipToTime(curTS, "");
      }
    }

    saveURL();
  });

  let fpopen = false;
  // Date/time field
  // https://flatpickr.js.org
  const tzOffSec = new Date().getTimezoneOffset() * 60;
  const fp = flatpickr("#flatpickr", {
    enableTime: OUTAGE_CONFIG["dtSelectorShowTime"],
    time_24hr: true,
    allowInput: true,
    wrap: true,
    minDate: new Date(
      (outageState.date_range["start"]["timestamp"] + tzOffSec) * 1000,
    ),
    maxDate: new Date(
      (outageState.date_range["end"]["timestamp"] + tzOffSec) * 1000,
    ),
    onClose: function () {
      fpopen = false;
      skipToTime(getDatepickerTS(), "");
    },
    onOpen: function () {
      playbackIsActive = false;
      timeControlsStatus(playbackIsActive);
      // let p = $('#flatpickr-input');
      //fp.setDate(p.val().replace(' ', 'T'), false); //no +"Z" here
      setTimeout(function () {
        fpopen = true;
      }, 200);
    },
  });
  fpInstance = fp;
  function fpClose() {
    if (fpopen) {
      $("#flatpickr-input").blur();
      fp.close();
    }
  }
  map.on("pointerdown", fpClose);
  $("#flatpickr-input").on("mouseup", fpClose);

  function getDatepickerTS() {
    const d = fp.selectedDates[0]; //problem here is timezone
    if (!d) return null;
    return d.getTime() / 1000 - d.getTimezoneOffset() * 60; //to UTC
  }

  function place_hurricanes(data) {
    hurricaneSource.clear();
    if ("hurricaneset" in data) {
      const allh = data.hurricaneset;
      for (let i = 0; i < allh.length; ++i) {
        const lat = parseFloat(allh[i]["lat"]);
        const lon = parseFloat(allh[i]["lon"]);
        const coord = fromLonLat([lon, lat]);
        const hStyle = new Style({
          image: hIcon,
          text: new Text({
            font: "bold 18px Calibri, sans-serif",
            fill: new Fill({ color: [0, 192, 0, 0.8] }),
            //stroke: new ol.style.Stroke({color: '#fff', width: 2}),
            offsetY: -30,
            text: allh[i]["info"],
          }),
        });
        const hFeature = new Feature({
          geometry: new Point(coord),
          //name: allh[i]["info"],
          //strength: 100,
        });
        hFeature.setStyle(hStyle);
        hurricaneSource.addFeature(hFeature);
        let txt = allh[i]["info"];
        txt = txt.replace("T.S.", "Tropical Storm");
        txt = txt.replace("T.D.", "Tropical Depression");
        hFeature.ANTlabel = txt;
        hFeature.ANTcoord = coord;
      }
    }
  }

  function showHurricanes(v) {
    hurricaneLayer.setVisible(v != 0);
  }

  function flashDialog(html_msg, css_class, buttonf, show_ok, timeouts) {
    $("#info-modal-msg").html(html_msg);
    $("#info-modal").attr("class", css_class);
    //show ok button if requested
    if (show_ok) {
      $("#veil").attr("class", "veil-show");
      $("#info-modal-button").attr("class", "info-modal-button-show");
      $("#info-modal-button").on("click", buttonf);
    } else {
      $("#info-modal-button").attr("class", "info-modal-button-hide");
      $("#veil").attr("class", "veil-hide");
      $("#info-modal-button").prop("onclick", null);
    }
    if (timeouts.length == 3) {
      $("#info-modal").fadeIn(timeouts[0]);
      setTimeout(function () {
        $("#info-modal").fadeOut(timeouts[1]);
      }, timeouts[2]);
    }
  }

  const clip = new ClipboardJS("#link-view");
  clip.on("success", async (event) => {
    event.clearSelection();
  });

  /**
   * Generate a link for the current map position/zoom
   */
  function saveURL() {
    let url =
      location.protocol + "//" + location.host + location.pathname + "?";
    const mapCtr = transform(
      map.getView().getCenter(),
      "EPSG:3857",
      "EPSG:4326",
    );

    outageState.lon = Math.floor(mapCtr[0] * 1000000) / 1000000;
    outageState.lat = Math.floor(mapCtr[1] * 1000000) / 1000000;
    outageState.zoom = Math.floor(map.getView().getZoom());

    url += "zoom=" + outageState.zoom;
    url += "&lon=" + outageState.lon;
    url += "&lat=" + outageState.lat;
    url += "&canvas=" + outageState.canvas;
    url += "&ts=" + outageState.timestamp;
    url += "&speed=" + outageState.speed;
    url += "&db=" + outageState.database;
    url += "&grid=" + outageState.grid;
    url += "&splash=false";
    url += "&poi_scale=" + outageState.poi_scale;
    url += drillDown !== null ? drillDown.getURLState() : "";
    url += outageState.hurricane != 0 ? "" : "&hurricane=0";
    url += outageState.coverage != 0 ? "&coverage=1" : "";
    $("#link-view").attr("data-clipboard-text", url);

    $("#info_database").html(outageState.database);
    $("#info_daterange").html(outageState.db_daterange);
    $("#info_grid").html(outageState.grid);
    $("#info_zoom").html(outageState.zoom);
    $("#info_lon").html(outageState.lon);
    $("#info_lat").html(outageState.lat);
    $("#info_poiscale").html(outageState.poi_scale);
    return url;
  }

  $("#info_hurricanes").on("change", function (e) {
    outageState.hurricane = e.target.checked ? 1 : 0;
    showHurricanes(e.target.checked);
  });
  $("#info_coverage").on("change", function (e) {
    outageState.coverage = e.target.checked ? 1 : 0;
    skipToTime(outageState.timestamp, "");
  });
  $("#link-view").on("mousedown", function () {
    saveURL();
    flashDialog(
      "Current view copied to clipboard",
      "view-copied-class",
      undefined,
      false,
      [500, 1000, 2300],
    );
  });
  $("#light-dark").on("click", function () {
    if (outageState.canvas === "dark") {
      outageState.canvas = "light";
    } else {
      outageState.canvas = "dark";
    }
    setLightTheme(outageState.canvas === "light");
    updateMap();
    //window.location.replace(saveURL());
  });

  /**
   * Initilization of the map center and resolution along with a retrieval of
   * the first dataset.
   */
  function init() {
    const initLat = outageState.lat,
      initLon = outageState.lon;
    playbackSpeed = parseInt(outageState.speed);

    $("#play-speed").html(playbackSpeed + "x");
    // Set the map center
    //map.getView().setCenter(transform([initLon, initLat], 'EPSG:4326', 'EPSG:3857'));
    map.getView().setCenter(fromLonLat([initLon, initLat]));

    poiLayer.setZIndex(1000);
    hurricaneLayer.setZIndex(1001);

    // Load placeholders for POIs
    allocateFeatures(1000);

    // Load the initial POI data
    $("#info_coverage").prop("checked", outageState.coverage != 0);
    $("#info_hurricanes").prop("checked", outageState.hurricane != 0);

    setLightTheme(outageState.canvas == "light");

    //hack xxx until I fix proper landing timestamp
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const ts = urlParams.get("ts");
    if (ts !== null && ts !== "") {
      outageState.timestamp = ts;
    }
    skipToTime(outageState.timestamp, "");
    showHurricanes(outageState.hurricane != 0);
    //saveURL();
    showDetails(debug);
    if (urlParams.get("ddown") && drillDown !== null) {
      drillDown.setURLState(urlParams.get("ddown"));
    }
  }
  /**
   * Retrieve the POI outage data for a particular date and time
   */
  function skipToTime(ts, forward) {
    //if animation is in play, curTS will be picked up
    if (playbackIsActive) {
      //go back so animation loop moves to forward
      curTS = nextTimestamp(ts, -1 /*backward*/);
      return;
    }
    updateView(ts, true, forward);
  }

  function updateView(ts, manual, forward) {
    if (!manual && !playbackIsActive) return;

    curTS = ts;
    // Record the elapsed time if this not a specified date/time
    $.ajax({
      url: "includes/outages-poi-fetcher.php",
      type: "GET",
      cache: true,
      dataType: "json",
      context: { reqTS: curTS },
      data: {
        format: "json",
        ts: ts,
        db: outageState.database,
        poi_scale: outageState.poi_scale,
        zoom: outageState.zoom,
        fwd: forward,
        coverage: outageState.coverage,
        hurricanes: 1,
      },
      error: function (e) {
        console.log("An error has occurred ", e);
        playbackIsActive = false;
        timeControlsStatus(playbackIsActive);
        //refreshTimeControls();
      },
      success: function (data) {
        if (data.timestamp === 0) {
          outageState.timestamp_next = 0;
          refreshTimeControls();
          if (playbackIsActive) {
            playbackIsActive = false;
            timeControlsStatus(playbackIsActive);
          }
          curTS = outageState.timestamp;
          return;
        }
        //ignore this poi data if curTS has changed (manual override)
        if (this.reqTS === curTS) {
          if (this.reqTS !== data.timestamp) {
            //data returned has skipped over the request
            //xxx need an indication of end-of-stream
            curTS = data.timestamp;
          }
          //current not changed since this
          //request was issued, proceed with updating
          const tzOffSec =
            new Date(data.timestamp * 1000).getTimezoneOffset() * 60;
          if (
            //typeof data.timestamp_next !== "undefined" &&
            //typeof outageState.date_range !== "undefined" &&
            outageState.date_range["end"]["timestamp"] < data.timestamp_next
          ) {
            fpInstance.set(
              "maxDate",
              new Date((data.timestamp_next + tzOffSec) * 1000),
            );
            outageState.date_range["end"]["timestamp"] = data.timestamp_next;
          }
          const currentDate = new Date((data.timestamp + tzOffSec) * 1000);
          if (fpInstance !== null) {
            fpInstance.setDate(currentDate, false, "");
          }
          //let s = new Date(data.timestamp*1000).toISOString();
          //p.val( s.substr(0, 16).replace('T', ' ') );

          outageState.timestamp = data.timestamp;
          outageState.timestamp_prev = data.timestamp_prev;
          outageState.timestamp_next = data.timestamp_next;
          outageState.grid = data.grid; //xxx don't want to change that
          outageState.database = data.db;
          outageState.db_date_range = data.db_daterange;
          outageState.hurricaneset = data.hurricaneset;
          outageState.dbMinTS = data.db_date_range_ts[0];
          outageState.dbMaxTS = data.db_date_range_ts[1];
          place_hurricanes(outageState);
          outageState.dd_isp = data.dd_isp;

          // Debug
          console.log(
            `count: ${data.pois.length}, debug: ${data.debug}, date: ${data.datestamp}`,
          );

          refreshTimeControls();
          if (outageState.timestamp_next === 0 && playbackIsActive) {
            playbackIsActive = false;
            timeControlsStatus(playbackIsActive);
          }
          loadPoi(data);
          if (drillDown !== null) {
            // update sidepanel here
            const ts = sp.RoundToDay(outageState.timestamp);
            if (sp) {
              const u = `/report/?stime=${ts}&duration=day&rtype=interest-1-lag&grid=0.5&limit=10&template=sp_embed.html.j2`;
              if (sp.url !== u) {
                sp.SetUrl(u);
                sp.LoadUrl();
              }
            }
            drillDown.updateContentTS(curTS);
          }
        }
        //xxx timeout should be adaptive re fetching time:
        //max(playbackIvalMs - how_long_it_took_ms, some_min)
        if (playbackIsActive) {
          setTimeout(function () {
            const nextTS = nextTimestamp(curTS, 1 /*forward*/);
            updateView(nextTS, false, true);
          }, playbackIvalMs);
        }
      },
    });
  }

  if (drillDown !== null) {
    drillDown.timeTravelRequest = function (ts) {
      playbackIsActive = false;
      timeControlsStatus(playbackIsActive);
      skipToTime(ts, "");
    };
  }

  /**
   * Load POI outage data with corresponding coordinates and styles (color, radius)
   */
  function loadPoi(poiData) {
    let coord, radius;
    const plen = poiData.pois.length;
    // Scale the POI to the current zoom level
    let flen = poiSource.getFeatures().length;
    if (flen < plen) {
      allocateFeatures(plen - flen); //additional, may invalidate features
    }
    const features = poiSource.getFeatures();
    flen = features.length;

    for (let i = 0; i < flen; ++i) {
      if (i < plen) {
        const p = poiData.pois[i];
        //[$row["longitude"], $row["latitude"], $row["outage_count"], $row["block_count"]]
        //corner of the grid cell to center
        const lonlat = [p[0] + poiData.grid / 2, p[1] + poiData.grid / 2];
        coord = fromLonLat(lonlat);
        if (outageState.coverage) {
          radius = Math.sqrt(p[3]) * outageState.poi_scale * 1500;
        } else {
          if (p[2] == 0) {
            continue; //ignore
          }
          radius = Math.sqrt(p[2]) * outageState.poi_scale * 1500;
        }
        const geometry = new Circle(coord, radius);
        const poiStyle = new Style({
          geometry: geometry,
          fill: new Fill({
            color:
              "rgba(" +
              heatmap(p[2] * OUTAGE_CONFIG["colorScale"], p[3]) +
              ",.7)",
          }),
          stroke: null,
          //smaller - on top
          zIndex: Math.abs(Math.floor((1000 - radius) * 100)),
        });
        features[i].setGeometry(geometry);
        features[i].setStyle(poiStyle);
      } else {
        features[i].setStyle(clearStyle);
        //feature.setGeometry(null);
      }
    }
  }

  /**
   * Allocate and add  Features as placeholders for outages
   */
  function allocateFeatures(n) {
    for (let i = 0; i < n; ++i) {
      poiSource.addFeature(new Feature({ style: clearStyle }));
    }
  }

  function showDetails(open) {
    const d = $("#debug");
    const t = $("#details-tab");
    d.data("is_open", open);
    if (open) {
      saveURL();
      d.show();
      t.html("Hide Details  &#9650;");
    } else {
      d.hide();
      t.html("Show Details  &#9660;");
    }
  }

  // Toggle details
  $("#details-tab").on("click", function () {
    showDetails(!$("#debug").data("is_open"));
  });

  if (sp !== null) {
    sp.SetRowClick(function (ts, lat, lon) {
      skipToTime(ts, "");
      const c = transform([lon, lat], "EPSG:4326", "EPSG:3857");
      map.getView().animate({
        center: c,
        duration: 500,
      });
    });

    const spSetUrl = () => {
      const ts = sp.RoundToDay(outageState.timestamp);
      sp.SetUrl(
        `/report/?stime=${ts}&duration=day&rtype=interest-1-lag&grid=0.5&limit=10&template=sp_embed.html.j2`,
      );
    };
    sp.SetOnToggle(() => {
      if (sp.isopen) spSetUrl();
      playbackIsActive = false;
    });
  }

  if (outageState.splash) {
    flashDialog(
      $("#welcome").html(),
      "view-landing-show",
      function () {
        $("#veil").attr("class", "veil-hide");
        $("#info-modal").attr("class", "view-landing-hide");
        if ($("#splashcookie").prop("checked")) {
          document.cookie = "showSplash=false; max-age=8640000; path=/";
        }
      },
      true,
      [],
    );
  }
});
